export default class CallFlowService {

  /** @ngInject **/
  constructor(
    $http,
    assetService,
    ngAuthSettings
  ) {
    this.$http = $http;
    this.assetService = assetService;
    this.ngAuthSettings = ngAuthSettings;
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
  }

  async getCallFlowTrees(accountId) {
    const url = this.#serviceBaseUrl(accountId) + '/basic';
    const result = await this.$http.get(url);
    return result.data;
  }

  async getCallFlowTree(accountId, treeId) {
    const url = this.#serviceBaseUrl(accountId, treeId);
    const result = await this.$http.get(url);
    return result;
  }

  async duplicateCallFlowTree(accountId, treeId) {
    const url = this.#serviceBaseUrl(accountId, treeId) + '/clone';
    const result = await this.$http.post(url);
    return result;
  }

  async getAvailableTemplates(accountId) {
    const url = this.#serviceBaseUrl(accountId) + '/templates';
    const result = await this.$http.get(url);
    return result.data;
  }

  async initializeCallFlowTreeTemplate(accountId, templateId, name) {
    const url = this.#serviceBaseUrl(accountId) + '/initialize/' + templateId;
    const data = {
      name: name
    };

    const result = await this.$http.post(url, data);
    return result;
  }

  async initializeCallFlowTree(accountId, name) {
    const url = this.#serviceBaseUrl(accountId) + '/initialize';
    const data = {
      name: name
    };
    const result = await this.$http.post(url, data);
    return result;
  }

  async attachNode(accountId, node, name, parentNodeId, tree, onSuccess, criteria) {
    const parentIsRoot = parentNodeId == 'root';
    const parentNode = parentIsRoot ? tree.root : tree.nodes[node.parentNodeId];
    const url = this.#serviceBaseUrl(accountId) + '/node';
    const data = {
      name: name,
      node: {
        nodeTypeId: node.nodeTypeId,
        stepName: node.displayName,
        settings: node.settings
      },
      ivrTree: tree,
      parentNodeId: parentNodeId,
      criteria: criteria,
      index: parentNode.childLinks.length,
      onSuccess: onSuccess,
      failOnError: false,
    };
    const result = await this.$http.post(url, data);
    return result;
  }

  async updateNode(accountId, tree, node) {
    const url = this.#serviceBaseUrl(accountId) + '/editNode';
    const data = {
      nodeId: node.id,
      node: node,
      ivrTree: tree,
      failOnError: false
    };
    const result = await this.$http.patch(url, data);
    return result;
  }

  async updateLink(accountId, tree, nodeId, parentNodeId, index, criteria, onSuccess, metaData) {
    const url = this.#serviceBaseUrl(accountId) + '/editLink';
    const childLinkIndex = _.findIndex(tree.nodes[parentNodeId].childLinks, {
      childNodeId: nodeId
    });
    const originalChildLink = tree.nodes[parentNodeId].childLinks[childLinkIndex];
    const data = {
      parentNodeId: parentNodeId,
      nodeId: nodeId,
      index: typeof index === 'number' ? index : childLinkIndex,
      onSuccess: typeof onSuccess === 'boolean' ? onSuccess : originalChildLink.onSuccess,
      metaData: metaData ? metaData : originalChildLink.metaData,
      criteria: criteria ? criteria : originalChildLink.criteria,
      ivrTree: tree
    };
    const result = await this.$http.patch(url, data);
    return result;
  }

  async removeNode(accountId, tree, nodeId, parentNodeId) {
    const url = this.#serviceBaseUrl(accountId) + '/removeNode/';
    const data = {
      nodeId: nodeId,
      ivrTree: tree,
      parentNodeId: parentNodeId
    };
    const result = await this.$http.patch(url, data);
    return result;
  }

  async getAvailableNodes(accountId, tree, parentNodeId) {
    const url = this.#serviceBaseUrl(accountId) + '/availableNodes';
    const data = {
      parentNodeId: parentNodeId,
      ivrTree: tree
    };
    const result = await this.$http.post(url, data);
    return result.data.nodes;
  }

  async getAvailableTags(accountId, tree, parentNodeId) {
    const url = this.#serviceBaseUrl(accountId) + '/availableTags';
    const data = {
      parentNodeId: parentNodeId,
      ivrTree: tree
    };
    const result = await this.$http.post(url, data);
    return result.data.tags;
  }

  async commitTree(accountId, tree) {
    const url = this.#serviceBaseUrl(accountId) + '/finalizeTree/';
    const data = {
      ivrTree: tree
    };
    const result = await this.$http.post(url, data);
    return result;
  }
  async saveDraftTree(accountId, tree) {
    const url = this.#serviceBaseUrl(accountId) + '/draft/';
    const data = {
      ivrTree: tree
    };
    const result = await this.$http.post(url, data);
    return result;
  }
  async getCallFlowTreeReferences(accountId, treeId) {
    const url = this.#serviceBaseUrl(accountId, treeId) + '/InboundReferences';
    const result = await this.$http.get(url);
    return result;
  }

  async deleteCallFlowTree(accountId, treeId, force) {
    const url = this.#serviceBaseUrl(accountId, treeId) + '?force=' + !!force;
    const result = await this.$http.delete(url);
    return result;
  }

  #serviceBaseUrl(accountId, treeId) {
    return this.serviceBaseUri + accountId + '/callflow' + (treeId ? '/' + treeId : '');
  }
}